import { AppContext } from '@/ui/Context';
import { useSlideout } from '@/ui/hooks';
import { useContactManagementCustomization } from '@juvare/alert-ui/ui/hooks/useContactManagementCustomization';
import { usePermission } from '@juvare/contact-management/ui/hooks';
import { MissionContextProvider } from '@juvare/missions/ui/providers';
import React from 'react';
import { ParticipantDetailsComponent } from '../components';

export const MissionProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
    const appContext = React.useContext(AppContext);
    const { handlePersonIdReset, handlePersonIdSelect, selectedPersonId, menuItems } = useSlideout();
    const { requireAnySystemPermission } = usePermission();
    const { notificationConfig } = useContactManagementCustomization();

    if (!appContext.currentUser?.userId) {
        return null;
    }

    const sharingOptions = requireAnySystemPermission('allow-create-public-mission')
        ? [
              {
                  icon: 'material-groups',
                  type: 'public',
                  label: 'Public (Everyone)',
                  description: 'Your mission will be launched for public. Click Launch & add shift to finish the step.',
              },
          ]
        : [];

    sharingOptions.push({
        icon: 'material-group-add',
        type: 'organizations',
        label: 'Specific Organization',
        description: 'Your mission will be launched for Specific Organization above. Click Launch & add shift to finish the step.',
    });

    return (
        <MissionContextProvider
            onAccountNotificationSend={notificationConfig?.onAccountNotificationSend}
            onParticipantSelect={handlePersonIdSelect}
            onParticipantReset={handlePersonIdReset}
            participantId={selectedPersonId}
            participantDetailsComponent={ParticipantDetailsComponent}
            slideoutMenuItems={menuItems}
        >
            {children}
        </MissionContextProvider>
    );
};
